import { ROUTES } from '@constants'

export const DEFAULT_TITLE_TAB = 'Wiskey'

export const TITLE_TABS: { [key: string]: string } = {
  '/windows': `Windows - ${DEFAULT_TITLE_TAB}`,
  '/diagrams': `Diagrams - ${DEFAULT_TITLE_TAB}`,
  '/tooltips': `Tooltips - ${DEFAULT_TITLE_TAB}`,
  '/style_settings': `Style Settings - ${DEFAULT_TITLE_TAB}`,
  '/search_assistants': `Search Assistants - ${DEFAULT_TITLE_TAB}`,
  '/variables': `Variables - ${DEFAULT_TITLE_TAB}`,
  '/dropdown_entities': `Dropdown Entities - ${DEFAULT_TITLE_TAB}`,
  '/list_controls': `List Controls - ${DEFAULT_TITLE_TAB}`,
  '/gantt': `Gantt-Chart - ${DEFAULT_TITLE_TAB}`,
  '/dictionary': `Dictionary - ${DEFAULT_TITLE_TAB}`,
  '/menu_setting': `Menu Setting - ${DEFAULT_TITLE_TAB}`,
  '/login': `Login - ${DEFAULT_TITLE_TAB}`,
  '/search_assistant': `Search Assistant - ${DEFAULT_TITLE_TAB}`,
  '/search': `Search - ${DEFAULT_TITLE_TAB}`,
  '/parameters': `Parameters - ${DEFAULT_TITLE_TAB}`,
  '/display_rules': `Display Rules - ${DEFAULT_TITLE_TAB}`,
  '/bar_chart': `Bar Chart - ${DEFAULT_TITLE_TAB}`,
  '/timelines': `TimeLines - ${DEFAULT_TITLE_TAB}`,
  '/choose_context': `Choose Context - ${DEFAULT_TITLE_TAB}`,
  '/contexts': `Contexts - ${DEFAULT_TITLE_TAB}`,
  '/views': `Views - ${DEFAULT_TITLE_TAB}`,
  '/forms': `Forms - ${DEFAULT_TITLE_TAB}`,
  '/context_menu': `Context Menu - ${DEFAULT_TITLE_TAB}`,
  '/control_panels': `Control Panels - ${DEFAULT_TITLE_TAB}`,
}

export const ARRAY_SUPPORTED_EDIT_PAGES = [
  ROUTES.CONFIG_VIEWS_EDIT,
  ROUTES.CONFIG_FORMS_EDIT,
  ROUTES.CONFIG_DROP_DOWN_ENTITY_EDIT,
  ROUTES.CONFIG_LIST_CONTROLS_EDIT,
]
